import { useEffect, useState } from "react";

// /leads + /leads/search use a 55/45 two-panel layout. The right
// panel has multiple stacked option tables, a map, save buttons -
// it needs ~500-600px to be usable. Below 1024px we collapse to a
// single primary panel: list when nothing is selected, detail when
// something is. Higher than the global `useIsMobile` (768px) on
// purpose - that's tablet-portrait, which is still too narrow for
// our two-panel content.
const COMPACT_BREAKPOINT = 1024;
const COMPACT_MEDIA_QUERY = `(max-width: ${COMPACT_BREAKPOINT - 1}px)`;

export const useIsCompactLayout = (): boolean => {
  const [isCompact, setIsCompact] = useState(
    () => window.matchMedia(COMPACT_MEDIA_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(COMPACT_MEDIA_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsCompact(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isCompact;
};
